'use strict';

import "@babel/polyfill";
import axios from 'axios';
import { accordion } from './view/_accordion';
import { topAjax } from './view/_topAjax';
import { fixedNav } from './view/_fixedNav';
import { floating } from './view/_floating';
import { header } from './view/_header';
import { noticeSort } from './view/_noticeSort';
import { parallax } from './view/_parallax';
import { price } from './view/_price';
import { scroll } from './view/_scroll';
import { slider } from './view/_slider';
import { toTop } from './view/_toTop';
